





























import Vue from 'vue';
import {Component, Prop, Watch} from "vue-property-decorator";
import User from "../../models/user/User";
import {Icon} from "@/helpers/icons";
import AsiCard from "../common/AsiCard.vue";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import {toISODateString} from "@/helpers/functions_asi";
import PlanningEntryList from "@/components/planningEntry/PlanningEntryList.vue";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import AsiBtn from "@/components/common/AsiBtn.vue";

@Component({
	components: {AsiBtn, PlanningEntryList, AsiCard}
})
export default class UserCardPendingReports extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	private icons = Icon;
	private loading: boolean = false;
	private entries: PlanningEntryListEntry[] = [];

	public created(): void {
		this.loadEntries();
	}

	@Watch('user', {deep: true})
	private onUserChanged(): void {
		this.loadEntries();
	}

	private loadEntries(): void {
		if (this.user === null) return;
		const filter = new PlanningEntryListFilter();
		filter.userId = this.user.id;
		filter.hasReports = false;
		filter.dateTo = toISODateString(new Date());

		const options = new AsiListTableOptions();
		options.sortBy = ['date'];
		options.sortDesc = [false];

		this.loading = true;
		this.$planningEntryService.planningEntries(filter, options)
			.then(res => this.entries = res.data)
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.loading = false)
	}

	private iconColor(entry: PlanningEntryListEntry): string | null {
		const dToday = new Date();
		dToday.setHours(0, 0, 0, 0);
		const dEntry = new Date(entry.date);
		dEntry.setHours(0, 0, 0, 0);

		if (dEntry.getTime() === dToday.getTime()) {
			return 'warning';
		} else if (dEntry.getTime() < dToday.getTime()) {
			return 'error';
		} else {
			return null;
		}
	}

}
